const Users = {
  loginPath: () => '/api/session',
  signUpPath: () => '/api/registration',
  confirmationPath: () => '/api/confirmation',
  passwordPath: () => '/api/password',
  accountDetailsPath: () => '/api/account_details',
};

export default Users;
